import { render, staticRenderFns } from "./StaffHeader.vue?vue&type=template&id=a8bd8b0a"
import script from "./StaffHeader.vue?vue&type=script&lang=js"
export * from "./StaffHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports